module.exports = __webpack_public_path__ + "static/pam-city-4391006faa640b96cc686dd0fa71c0f3.jpg";